import { render, staticRenderFns } from "./signUp.vue?vue&type=template&id=6fce2479&"
import script from "./signUp.vue?vue&type=script&lang=js&"
export * from "./signUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports